import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ModalCrearConsultaComponent } from '../dialogs/modal-crear-consulta/modal-crear-consulta.component'
import { apiService } from '../../../../service/api.service'
import { ResponseForoModel, ForoModel, ContactoModel } from '../../../../model/Contacto.model'
import { MatSort } from '@angular/material/sort';
// import { NgControl } from '@angular/forms'
@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {
  displayedColumns=[];
  dataSource : MatTableDataSource<ForoModel>;
  @ViewChild(MatSort) sort: MatSort;
  columnNames = [
    { id: 'nombre', value: 'nombre' },
    { id: 'enviadoPor', value: 'nombre' },
    { id: 'asunto', value: 'asunto' },
    { id: 'cantRespuestas', value: 'cantRespuestas' },
    { id: 'fecha',  value: 'fecha' },
    { id: 'acciones', value: 'acciones' }
  ];
  responseForo = new ResponseForoModel();
  cargando = true
  formContacto = new ContactoModel();
  activeTabContacto;
  consultaEnviada = false;
  constructor(
    public dialog: MatDialog,
    public api: apiService,
    // public control: NgControl
  ) { }

  ngOnInit(): void {
    this.activeTabContacto = this.api.activeTabContacto;
    this.api.activeTabContacto = 0;
    this.getForo(); 
 
  }

  getForo(){
    this.api.API_POST_obtenerForo().subscribe((response:ResponseForoModel) => {
      this.responseForo = response;
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<ForoModel>(this.responseForo.payload);
      this.sortData();
      this.cargando =false; 
    },
    (err) => {
      console.log(err)
    })
  }

  sortData(){
    setTimeout(() => {
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'fecha': return new Date(item.fecha).getDate;
          default: return item[property];
        }
      };
      this.dataSource.sort = this.sort;
 
    }, 200);
  }

  verForo(foro:ForoModel){
    this.api.idForo = foro.idForo
    this.api.emitDireccionamiento('consulta');
  }

 
  enviarMensaje(){

    if(this.formContacto.asunto == null &&  this.formContacto.consulta == null){
      this.formContacto.asunto = '';
      this.formContacto.consulta  = '';
    }else if(this.formContacto.asunto != '' &&  this.formContacto.consulta != ''){
      this.consultaEnviada = true;
      this.formContacto.idJardin = this.api.dataJardin.id;
      this.api.API_POST_crearConsulta(this.formContacto).subscribe((response) => {
        this.formContacto = new ContactoModel();
        this.consultaEnviada = false;
      },
      (err) => {
        console.log(err)
      })
    }
  }
   

  nuevaConsulta(){
    const dialogRef = this.dialog.open(ModalCrearConsultaComponent,{
      disableClose: true ,
      width: '35%',
    });
  }

  irA(){
    this.api.emitDireccionamiento('consulta');
  }
}
